import UIfx from "uifx";
import clickSound from "../sounds/520954__redpanda69__snapping-closed-an-airpods-case.mp3";

const click = new UIfx(clickSound, {
  volume: 0.25,
  throttleMs: 100,
});

export default click;
